import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { PersonelEditComponent } from './personel-edit.component';
import { PersonelKartComponent } from './personel-kart.component';
import { PersonelKartSadeComponent } from './personel-kart-sade.component';

@DinamikBilesen({
  id: 'personel',
  baslik: 'Personel',
  aciklama: 'Personel kaydı',
  ikon: 'user',
  kategori: 'personel',
})
class Personel {
  paylas_kutusu = PersonelEditComponent;
  paylasilmis_kart = PersonelKartComponent;
  paylasilmis_kart_sade = PersonelKartSadeComponent;
}
